import { render, staticRenderFns } from "./video_10.vue?vue&type=template&id=2fd5dafa&scoped=true&"
var script = {}
import style0 from "./video_10.vue?vue&type=style&index=0&id=2fd5dafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5dafa",
  null
  
)

export default component.exports